import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["innerHTML"]

import { LIcon, LMarker, LTooltip } from "@vue-leaflet/vue-leaflet";
import { Landmark } from "@/models/Landmark";
import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'LandmarkMarker',
  props: {
  landmark: {
    type: Landmark,
    required: true,
  },
},
  setup(__props) {

const props = __props



const tooltip = computed(() => props.landmark.name.replace("\n", "<br/>"));

function getDiv(landmark: Landmark): HTMLElement {
  const elemWidth = 300;
  const yOffset = landmark.iconSize[1] - landmark.iconAnchor[1] + 3;
  const xOffset = -1 * (elemWidth / 2) + (landmark.iconAnchor[0] == 0 ? 15 : 0);

  const elem = document.createElement("div");
  elem.className = "landmark-label";
  elem.innerText = landmark.name;
  elem.style.transform = `translate(${xOffset}px, ${yOffset}px)`;
  elem.style.width = `${elemWidth}px`;
  return elem;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(LMarker), {
      "lat-lng": __props.landmark.posArray()
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(LIcon), {
          "icon-url": __props.landmark.icon,
          "icon-size": __props.landmark.iconSize,
          "icon-anchor": __props.landmark.iconAnchor,
          className: __props.landmark.navAid ? `navaid` : `noaid`
        }, null, 8, ["icon-url", "icon-size", "icon-anchor", "className"]),
        _createVNode(_unref(LTooltip), null, {
          default: _withCtx(() => [
            _createElementVNode("span", { innerHTML: _unref(tooltip) }, null, 8, _hoisted_1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["lat-lng"]),
    _createVNode(_unref(LMarker), {
      "lat-lng": __props.landmark.posArray()
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(LIcon), {
          html: getDiv(__props.landmark)
        }, null, 8, ["html"])
      ]),
      _: 1
    }, 8, ["lat-lng"])
  ], 64))
}
}

})